import { action } from 'mobx';
import { AbstractFormViewModelController } from '../../../../../../../infrastructure/implementations/form-viewmodel-controller';
import { FormVmItemConfigType, FormVmValueType } from '../../../../../../../infrastructure/form-viewmodel-controller';
import { CustomPageFormField } from '../../../../../../../modules/passport-pages/custom-pages';
import CONFIG from '../../../../../../../modules/event-links/config';
import { ILinkDTO } from '../../../../../../../api/meetings.dao';

type LinkProps = {
    data?: ILinkDTO;
};

export class LinkFormViewModel extends AbstractFormViewModelController {
    public static create(formProps: LinkProps, data?: ILinkDTO): LinkFormViewModel {
        return new LinkFormViewModel(data, formProps, CONFIG);
    }

    constructor(
        private readonly data: ILinkDTO,
        props: LinkProps,
        private readonly config: FormVmItemConfigType[],
    ) {
        super(props, 'Link', config);
    }

    @action.bound
    public setFieldValueByKey(key: string, value: FormVmValueType): void {
        if (this.data) this.data[key] = value;
        this.setValue(key, value);
    }
    public getFieldByKey(key: string): CustomPageFormField {
        if (this.data?.[key]) this.setValue(key, this.data?.[key]);
        return {
            value: this.data?.[key] ?? this.getValue(key),
            ...this.getValueValidationState(key)
        };
    }
    public getFieldConfigByKey(key: string): FormVmItemConfigType {
        return this.config.find(cnf => cnf.name === key);
    }


    public getFormFields() {
        return this.getVmState()
            .reduce((fields, field) => {
                fields[field.name] = field.value;
                return fields;
            }, {});
    }

    @action.bound
    public reset(): void {
        this.resetVm();
    }
}
